export default {
    path: '/404',
    name: 'notfound',
    component: () => import(/* webpackChunkName: "Index" */ '@/views/NotFound.vue')
}
